export const name = 'imageZoom' as const
export const ImageZoomAPISymbol = Symbol('ImageZoomAPISymbol')

export const IMAGE_ZOOM_QUERY = 'lightbox' as const
export const RUNTIME_DELIMETER = '_runtime_' as const
export const IMAGE_ZOOM_ID = 'imageZoomComp' as const
